import { LogLevel } from './log-level';
import { Publisher } from './publisher';
import { Type } from '@angular/core';

export class LoggerConfig {
    logLevel: LogLevel;
    publishers: Type<Publisher>[];
}
